import React,{useEffect} from "react";
import Navbar from "../components/Navbar";
import HeroOne from "../components/HeroOne";
import AboutUs from "../components/AboutUs";
import Services from "../components/Service";
import CTABanner from "../components/CTABanner";
import Experience from "../components/Experience";
import Projects from "../components/Projects";
import Blogs from "../components/Blogs";
import GetInTouch from "../components/GetInTouch";
import Footer from "../components/Footer";
import Clients from "../components/Clients";

export default function Index(){
   useEffect(() => {
  document.documentElement.setAttribute("dir", "ltr");

  const savedTheme = localStorage.getItem("theme");
  if (savedTheme === "dark") {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
}, []);
// const toggleTheme = () => {
//   const isDark = document.documentElement.classList.contains("dark");
//   if (isDark) {
//     document.documentElement.classList.remove("dark");
//     localStorage.setItem("theme", "light");
//   } else {
//     document.documentElement.classList.add("dark");
//     localStorage.setItem("theme", "dark");
//   }
// };


    return(
        <>
            <Navbar/>
            <HeroOne/>
            <AboutUs/>
           
            {/* <CTABanner/> */}
            <Experience/>
            <Projects/>
             <Services/>
            {/* <Clients/>  
            <Blogs/> */}
            <GetInTouch/>
            {/* <Footer/> */}
        </>
    )
}